import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorUpload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<SensorUpload, Error, File>, 'mutationKey' | 'mutationFn'>
}

export const useUploadSensorsRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<SensorUpload, Error, File>(
    [Entities.Sensors, 'upload'],
    async (file: File) => {
      const { data } = await api.v2AdminSensorsUploadPut(file)
      return data as unknown as SensorUpload
    },
    {
      ...options,
    },
  )
}
